import { render, staticRenderFns } from "./ManualRegistrationModal.vue?vue&type=template&id=fb51c734&"
import script from "./ManualRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./ManualRegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports